import { devtools } from "zustand/middleware";

export const withDevtools = (store: any, options: { name: string }) => {
  return process.env.ENV_TYPE === "local" ? devtools(store, options) : store;
};
